import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./PreviewModal.scss";
import LeftArrowIcon from "../../../components/icons/LeftArrowIcon";
import RightArrowIcon from "../../../components/icons/RightArrowIcon";

interface PreviewModalProps {
  open: boolean;
  onClose: () => void;
  images: string[];
  initialIndex?: number;
}

const PreviewModal: React.FC<PreviewModalProps> = ({
  open,
  onClose,
  images,
  initialIndex = 0,
}) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  useEffect(() => {
    if (open) setCurrentIndex(initialIndex);
  }, [open, initialIndex]);

  const handlePrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      maxWidth={false}
      className="configuration-view-preview-modal-root"
      classes={{
        paper: "configuration-view-preview-modal-paper",
      }}
    >
      {/* Background container: Ispe click karne se modal band hoga */}
      <div
        className="configuration-view-preview-modal-container"
        onClick={onClose}
      >
        <IconButton
          className="configuration-view-preview-close-btn"
          onClick={(e) => {
            e.stopPropagation(); // Icon click pe stop propagation
            onClose();
          }}
        >
          <CloseIcon />
        </IconButton>

        <div className="configuration-view-preview-modal-body">
          {images.length > 0 && (
            <img
              src={images[currentIndex]}
              alt={`Preview ${currentIndex + 1}`}
              className="configuration-view-preview-image"
              // Image par click karne se modal band NAHI hoga
              onClick={(e) => e.stopPropagation()}
            />
          )}

          {images.length > 1 && (
            <>
              <button
                className="configuration-view-carousel-button configuration-view-left"
                onClick={handlePrev}
              >
                <LeftArrowIcon />
              </button>
              <button
                className="configuration-view-carousel-button configuration-view-right"
                onClick={handleNext}
              >
                <RightArrowIcon />
              </button>
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default PreviewModal;